module.exports = __webpack_public_path__ + "assets/img/mecha-4693946f.png";